<template>
  <div class="buyNum">
    <div class="dec" @click="sub">-</div>
    <div class="num">{{num}}</div>
    <div class="add" @click="add">+</div>
  </div>
</template>

<script>
export default {
  props: ['initCount', 'cartId', 'goodsId'],
  data () {
    return {
      num: 1,
      resObj: {cartId: 0, goodsid: 0, type: 'add'}
    }
  },
  created () {
    this.num = this.initCount
  },
  methods: {
    sub () {
      if (this.num <= 1) {
        this.num = 1
      } else if (this.num > 1) {
        this.num--
      }
      this.sendMessage('sub')
    },
    add () {
      this.num++
      this.sendMessage('add')
    },
    sendMessage (type) {
      this.resObj.type = type
      this.resObj.cartId = this.cartId
      this.resObj.goodsid = this.goodsId
      this.$emit('carDataObj', this.resObj)
    }
  }
}
</script>

<style scoped>
  .buyNum {
    margin: 10px 0;
    width: 200px;
    /*position: absolute;*/
    /*left: 80px;*/
    /*top: -18px;*/
    display: flex;
    border: 1px solid #F0F0F0;
  }
  .buyNum div {
    line-height: 30px;
    font-size: 25px;
    flex: 1;
    text-align: center;
    cursor: pointer;
  }
  .buyNum div:nth-child(2) {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/cartInputNumber.vue